import { render, staticRenderFns } from "./DownlineHistoryBody.vue?vue&type=template&id=fe545ad8&"
import script from "./DownlineHistoryBody.vue?vue&type=script&lang=ts&"
export * from "./DownlineHistoryBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports